const resource = {
  "general.save": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"保存"}},
  "general.update": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"保存"}},
  "general.edit": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"编辑"}},
  "general.delete": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"删除"}},
  "general.create": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"创建"}},
  "general.register": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"创建"}},
  "general.search": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"搜索"}},
  "general.submit": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"提交"}},
  "general.none": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"无"}},
  "general.cancel": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"取消"}},
  "general.close": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"关闭"}},
  "general.all": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"全部"}},
  "general.confirm": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"确认"}},
  "general.error_reload": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"发生错误。请刷新页面。"}},
  "general.error_retry": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"发生错误。请重试。"}},
  "general.error": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"发生错误。"}},
  "general.name": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"姓名"}},
  "general.phone": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"电话号码"}},
  "general.skip": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"跳过"}},
  "general.next": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"下一步"}},
  "general.done": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"完成"}},
  "date.weekday.0": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"日"}},
  "date.weekday.1": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"一"}},
  "date.weekday.2": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"二"}},
  "date.weekday.3": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"三"}},
  "date.weekday.4": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"四"}},
  "date.weekday.5": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"五"}},
  "date.weekday.6": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"六"}},
  "date.month.0": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"1月"}},
  "date.month.1": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"2月"}},
  "date.month.2": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"3月"}},
  "date.month.3": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"4月"}},
  "date.month.4": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"5月"}},
  "date.month.5": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"6月"}},
  "date.month.6": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"7月"}},
  "date.month.7": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"8月"}},
  "date.month.8": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"9月"}},
  "date.month.9": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"10月"}},
  "date.month.10": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"11月"}},
  "date.month.11": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"12月"}},
  "date.today": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"今天"}},
  "date.day_short": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"日"}},
  "date.week_short": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"周"}},
  "date.month_short": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"月"}},
  "date.year_short": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"年"}},
  "date.full_datetime": {"t":0,"b":{"t":2,"i":[{"t":4,"k":"year"},{"t":3,"v":"年"},{"t":4,"k":"month"},{"t":4,"k":"day"},{"t":3,"v":"日("},{"t":4,"k":"weekday"},{"t":3,"v":") "},{"t":4,"k":"time"}]}},
  "date.short_date": {"t":0,"b":{"t":2,"i":[{"t":4,"k":"month"},{"t":4,"k":"day"},{"t":3,"v":"日"},{"t":4,"k":"weekday"}]}},
  "user.profile": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"个人资料"}},
  "user.employee_id": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"员工编号"}},
  "user.furigana": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"假名注音"}},
  "user.preferred_branch": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"常用门店"}},
  "user.preferred_branch_tooltip": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"选择门店时，常用门店将始终显示在列表顶部。"}},
  "user.language": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"语言"}},
  "user.default_language": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"默认"}},
  "user.smarthr_api_token": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"SmartHR 出勤 API 令牌"}},
  "user.smarthr_api_token_tooltip": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"要连接到 SmartHR 出勤系统，需要在SmartHR出勤侧生成API令牌并在此处注册。"}},
  "user.api_token_not_set": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"未设置 API 令牌。"}},
  "user.api_token_set": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"已设置 API 令牌。"}},
  "user.email": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"邮箱地址"}},
  "user.no_login_email": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"无登录邮箱"}},
  "user.change_email": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"更改邮箱"}},
  "user.password": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"密码"}},
  "user.password_already_set": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"密码已设置。"}},
  "user.password_not_set": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"未设置密码。"}},
  "user.change_password": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"更改密码"}},
  "user.create_password": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"创建密码"}},
  "user.new_api_token": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"新的 API 令牌"}},
  "set_mfa_password.new_password": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"新密码"}},
  "set_mfa_password.password_placeholder": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"请输入密码"}},
  "set_mfa_password.valid_characters_requirement": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"请仅使用半角英文字母、数字和符号。"}},
  "set_mfa_password.length_requirement": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"密码长度必须为 4 到 72 个字符。"}},
  "set_mfa_password.confirm_password": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"再次输入新密码"}},
  "set_mfa_password.invalid_input": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"输入无效。请检查密码要求。"}},
  "set_mfa_password.passwords_not_match": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"两次输入的密码不一致。"}},
  "set_mfa_password.request_failed": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"登录失败。"}},
  "dash.title_default": {"t":0,"b":{"t":1,"c":[{"t":2,"i":[{"t":3}],"s":"oplus"},{"t":2,"i":[{"t":3}],"s":"免费排班管理"}]}},
  "dash.meta_description": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"免费排班管理"}},
  "dash.nav.master": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"主页"}},
  "dash.nav.profile": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"编辑资料"}},
  "dash.nav.notifications": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"通知设置"}},
  "dash.nav.api": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"API 集成"}},
  "dash.nav.referral": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"推荐活动"}},
  "dash.nav.logout": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"退出登录"}},
  "dash.nav.onboarding": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"入门指引"}},
  "dash.nav.charts": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"图表"}},
  "dash.nav.staff": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"员工管理"}},
  "dash.nav.shift": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"排班管理"}},
  "dash.nav.roles": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"岗位管理"}},
  "dash.nav.attendance": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"出勤管理"}},
  "dash.nav.pto": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"带薪休假管理"}},
  "dash.nav.requests": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"申请/审批"}},
  "dash.nav.smarthr": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"员工页面"}},
  "dash.nav.plan": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"计划管理"}},
  "dash.nav.announce": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"公告"}},
  "dash.nav.settings": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"设置"}},
  "dash.nav.qr_punch": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"打卡二维码"}},
  "dash.nav.branch_punch": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"门店打卡"}},
  "dash.nav.shift_submit": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"提交班次"}},
  "dash.nav.timecard": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"打卡记录"}},
  "dash.nav.board": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"公告板"}},
  "dash.nav.upgrade": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"升级"}},
  "dash.nav.help": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"帮助"}},
  "dash.nav.news": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"最新动态"}},
  "dash.nav.contact": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"联系我们"}},
  "dash.nav.demo_tour": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"预约演示"}},
  "dash.nav.basics": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"基本操作"}},
  "dash.nav.feedback": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"意见反馈"}},
  "dash.slot.label_placeholder": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"可选，例如：收银、清洁"}},
  "dash.slot.label": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"标签"}},
  "dash.slot.from": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"开始"}},
  "dash.slot.to": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"结束"}},
  "dash.slot.break_placeholder": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"可选：0.25、0.5、0.75、1.0"}},
  "dash.slot.break": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"休息时间"}},
  "dash.slot.wage": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"时薪"}},
  "dash.slot.help": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"支援"}},
  "dash.slot.section": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"分区"}},
  "dash.slot.shift_request": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"排班申请"}},
  "dash.slot.quick_add": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"快速添加"}},
  "dash.slot.pto": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"带薪休假"}},
  "dash.slot.half_pto": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"半天带薪休假"}},
  "dash.slot.legal_holiday": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"法定休息日"}},
  "dash.slot.non_legal_holiday": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"非法定休息日"}},
  "dash.slot.pattern": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"模式"}},
  "dash.slot.confirm": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"确认"}},
  "dash.slot.weekly_repeat": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"每周重复"}},
  "dash.slot.memo": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"备注"}},
  "dash.slot.activity": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"动态"}},
  "dash.slot.comment_placeholder": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"评论"}},
  "dash.slot.notify_email": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"邮件通知"}},
  "dash.slot.break_checkbox": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"休息"}},
  "dash.section.roles": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"岗位分区"}},
  "dash.upgrade.required": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"需要升级"}},
  "dash.upgrade.description": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"升级到 Pro 套餐即可使用此功能"}},
  "dash.upgrade.details": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"查看详情"}},
  "dash.repeat.delete_title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"删除重复班次"}},
  "dash.repeat.delete_all": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"删除此班次及之后所有班次"}},
  "dash.repeat.delete_only": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"仅删除此班次"}},
  "dash.repeat.confirm": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"确认"}},
  "dash.csv.title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"CSV 岗位导入"}},
  "dash.csv.description": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"通过 CSV 文件注册岗位并设置所需人数"}},
  "dash.csv.sample": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"CSV 文件示例"}},
  "dash.csv.remove_dates": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"移除列出的日期"}},
  "dash.csv.import": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"导入"}},
  "dash.ie.title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"致 Internet Explorer 用户"}},
  "dash.ie.message_1": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"您使用的浏览器"}},
  "dash.ie.message_2": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Internet Explorer，不受支持。"}},
  "dash.ie.use_these": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"请使用以下浏览器之一。"}},
  "dash.ie.install": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"安装并使用"}},
  "notif.error": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"无法编辑通知设置。"}},
  "notif.col.shift_comment": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"班次评论"}},
  "notif.col.shift_ask": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"排班申请"}},
  "notif.col.shift_reply": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"排班回复"}},
  "notif.col.pto": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"带薪休假审批/拒绝"}},
  "notif.col.overtime": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"加班提醒"}},
  "notif.all_read": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"已全部处理完毕。"}},
  "notif.mark_all_read_tooltip": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"全部标记为已读"}},
  "notif.title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"通知"}},
  "notif.board_comment": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"公告板评论"}},
  "notif.shift_comment": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"班次评论"}},
  "api.title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"API 使用指南"}},
  "api.token_auth_title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"令牌认证"}},
  "api.header_required_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"所有请求都需要以下请求头"}},
  "api.token_instructions": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"如果您没有令牌，请使用下方按钮生成。您也可以重新生成令牌，但这样会使之前的令牌失效。"}},
  "api.user_id_label": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"用户 ID"}},
  "api.token_label": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"令牌"}},
  "api.issue": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"生成"}},
  "api.endpoint": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"接口地址"}},
  "api.request_params": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"请求参数"}},
  "api.response_fields": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"响应字段"}},
  "api.curl_sample": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"CURL 请求示例"}},
  "api.required": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"必填"}},
  "api.optional": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"可选"}},
  "api.pagination_info": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"分页信息"}},
  "api.field.company_id": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"公司 ID"}},
  "api.field.company_name": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"公司名称"}},
  "api.field.branch_id": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"门店 ID"}},
  "api.field.branch_name": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"门店名称"}},
  "api.field.employee_id": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"员工编号"}},
  "api.field.employee_ids_list": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"员工编号列表"}},
  "api.field.owner_ids_list": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"所有者 ID 列表"}},
  "api.field.name": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"姓名"}},
  "api.field.email": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"邮箱"}},
  "api.field.cursor": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"用于获取下一页的游标"}},
  "api.field.pagination_done": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"表示分页是否已结束的标志"}},
  "api.shift.title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"排班 API"}},
  "api.shift.description": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"获取指定时间段内的排班"}},
  "api.shift.from_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"要获取的排班期间的开始日期，格式：YYYY-MM-DD"}},
  "api.shift.to_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"要获取的排班期间的结束日期，格式：YYYY-MM-DD"}},
  "api.shift.locked_only_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"设为 true 时仅返回已确定的班次"}},
  "api.shift.id_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"班次 ID"}},
  "api.shift.from_time_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"班次开始时间"}},
  "api.shift.to_time_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"班次结束时间"}},
  "api.shift.type_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"类型 (0: 普通, 1: O, 2: X, 3: 带薪休假, 4: 休息, 5: 半天带薪休假, 6: 法定休息日, 7: 非法定休息日, 100: (KOT) 带薪休假, 101: (KOT) 上午休, 102: (KOT) 下午休, 103: (KOT) 按小时休假)"}},
  "api.shift.role_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"岗位名称"}},
  "api.shift.store_id_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"门店 ID"}},
  "api.shift.sections_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"分区班次列表"}},
  "api.shift.is_off_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"该班次是否为休息日，或该分区是否为休息时段"}},
  "api.shift.locked_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"已确定"}},
  "api.employee.title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"员工 API"}},
  "api.employee.description": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"获取员工列表"}},
  "api.employee.companies_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"各公司的信息"}},
  "api.employee.company_employee_id_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"公司内的员工编号"}},
  "api.employee.linked_mf_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"与 MF 关联"}},
  "api.branch.title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"门店 API"}},
  "api.branch.description": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"获取门店信息"}},
  "api.branch_list.title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"门店列表 API"}},
  "api.branch_list.description": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"获取指定公司的门店列表"}},
  "api.branch_list.user_or_group_required": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"userID 和 groupID 必须提供其中一个"}},
  "api.branch_list.data_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"门店列表"}},
  "api.token_upload.title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"上传外部集成令牌"}},
  "api.user_bulk_import.title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"批量导入用户"}},
  "api.user_bulk_import.employee_link_id_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"员工关联 ID"}},
  "api.user_bulk_import.birth_date_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"出生日期"}},
  "api.user_bulk_import.branch_id_or_code_required": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"branch_id 和 branch_code 必须提供其中一个"}},
  "api.user_bulk_import.branch_id_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"门店 ID"}},
  "api.user_bulk_import.branch_code_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"门店关联 ID"}},
  "api.user_bulk_import.tags_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"标签"}},
  "api.user_bulk_import.transport_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"交通补贴"}},
  "api.user_bulk_import.max_month_workdays_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"每月最大出勤天数"}},
  "api.user_bulk_import.min_week_labor_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"每周最低劳动时间（分钟）"}},
  "api.user_bulk_import.max_week_labor_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"每周最大劳动时间（分钟）"}},
  "api.user_bulk_import.min_month_labor_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"每月最低劳动时间（分钟）"}},
  "api.user_bulk_import.max_month_labor_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"每月最大劳动时间（分钟）"}},
  "api.branch_bulk_import.title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"批量导入门店"}},
  "api.branch_bulk_import.name_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"门店名称"}},
  "api.branch_bulk_import.address_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"门店地址"}},
  "api.group_users.title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"群组用户列表"}},
  "api.group_users.id_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"群组用户 ID"}},
  "api.group_users.is_owner_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"表示该用户是否为该群组的所有者。"}},
  "api.group_users_update.title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"更新群组用户"}},
  "api.group_users_update.edit_all_branches_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"将群组员工编号应用到所有门店"}},
  "api.group_users_delete.title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"删除群组用户"}},
  "referral.header": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"每次推荐最高可获得 ¥50,000！"}},
  "referral.subtitle_line1": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"您身边有经营或管理企业的朋友吗？"}},
  "referral.subtitle_line2": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"请将 oplus 推荐给他们 - 如果被推荐的公司签约成功，我们将赠送您喜欢的礼品卡。"}},
  "referral.learn_more": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"查看详情"}},
  "referral.step1_label": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"步骤 1"}},
  "referral.step1_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"推荐您认为可能从 oplus 中获益的公司的老板或负责人。"}},
  "referral.step2_label": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"步骤 2"}},
  "referral.step2_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"被推荐人注册 oplus 付费套餐。"}},
  "referral.step3_label": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"步骤 3"}},
  "referral.step3_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"作为对您推荐的感谢，我们将赠送您礼品卡。"}},
  "referral.rewards_title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"已获得的奖励"}},
  "referral.total_earned_label": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"目前已获得总额： "}},
  "referral.how_it_works_title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"*这是如何运作的？"}},
  "referral.how_it_works_intro": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"您推荐的公司规模越大，对方注册付费套餐时您获得的奖励就越大。"}},
  "referral.example_label": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"示例："}},
  "referral.how_it_works_example": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"如果一家拥有 250 名员工的公司通过您的推荐链接注册了 oplus 的付费套餐 - Pro 套餐、Pro+ 出勤套餐、自动排班生成功能或 oplus chat - 您将获得一张 ¥10,000 的礼品卡！"}},
  "referral.how_it_works_note": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"您可以推荐任意数量的公司。推荐越多，奖励越多。"}},
  "referral.table.company_size": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"公司规模（员工人数）"}},
  "referral.table.gift_card_amount": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"礼品卡奖励金额"}},
  "referral.tips_title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"充分利用 oplus 推荐计划的小贴士："}},
  "referral.tips.share_link": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"在公司网站或社交媒体上分享您的推荐链接。"}},
  "referral.tips.invite": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"发送推荐链接，或邀请合作伙伴、同事等商业联系人。"}},
  "referral.tips.introduce_features": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"向他们介绍 oplus 的功能和优势。"}},
  "referral.tips.visibility": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"使用醒目的设计或文字让您的推荐链接更突出。"}},
  "referral.tips.track_progress": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"随时关注您的推荐数量和奖励进度。"}},
  "referral.share.title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"请将 oplus 推荐给您的商业伙伴和联系人。"}},
  "referral.share.line_title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"直接通过 LINE 分享"}},
  "referral.share.line_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"（打开 LINE 将邀请链接发送给朋友或同事）"}},
  "referral.share.line_message": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"您好！让我们用 oplus 轻松管理公司的排班吧。请点击下方链接！"}},
  "referral.share.line_button": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"通过 LINE 分享"}},
  "referral.share.link_title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"您的推荐链接"}},
  "referral.share.link_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"（将此链接粘贴到聊天、社交媒体或邮件中以邀请他人使用 oplus）"}},
  "referral.share.copy_button": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"复制链接"}},
  "referral.history.title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"推荐历史"}},
  "referral.history.company_name": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"公司名称"}},
  "referral.history.status": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"状态"}},
  "referral.history.reward": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"奖励"}},
  "referral.history.accepted": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"已通过"}},
  "referral.history.pending_suffix": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"（待处理）"}},
  "referral.history.paid_suffix": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"（已发送）"}},
  "referral.history.pending": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"待处理"}},
  "referral.history.empty_title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"暂无推荐记录。"}},
  "referral.history.empty_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"不妨发送您的链接或邀请他人加入 oplus？- 每成功推荐一次，最高可获得 ¥50,000 的礼品卡！"}},
  "logout.confirm_message": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"确定要退出登录吗？"}},
  "logout.error": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"退出登录失败。"}},
  "branch_menu.search_placeholder": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"门店名称"}},
  "branch_menu.selected_branch": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"当前选中的门店"}},
  "punch_qr.access_required": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"正在启动二维码扫描器，请允许访问摄像头。"}},
  "punch_qr.hold_camera": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"请将门店打卡二维码对准摄像头。"}},
  "punch_qr.title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"打卡二维码"}},
  "punch_qr.description_line1": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"在员工页面点击“打卡”以启动摄像头。"}},
  "punch_qr.description_line2": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"将摄像头对准此二维码即可打卡。"}},
  "shift.aim_text.title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"■致在驻留期间于其他公司兼职或打工的人员"}},
  "shift.aim_text.body": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"按照入住时的承诺，请合并考虑您在运动员村的工作时间与在其他工作的工作时间，确保每周总工作时间不超过 40 小时，并据此申请休息日（不在运动员村工作的日子）。"}},
  "shift.aim_text.note1": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"*4 月至 6 月无需填写班次* "}},
  "shift.aim_text.note2": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"*抱歉给您带来不便，请使用下方“＜ 今天 ＞”右侧的“＞”按钮跳转至 7 月*"}},
  "shift.staff_lock_notice": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"班次已确定至 %s。如需更改已确定提交的班次，请直接联系您的排班管理员。"}},
  "shift.staff_lock_alert": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"班次已确定至“%s”。如需更改已确定提交的班次，请直接联系您的排班管理员。"}},
  "shift.col_date": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"日期"}},
  "shift.col_time": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"时间"}},
  "shift.col_create": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"创建"}},
  "shift.add_disabled_tooltip": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"因已满足所需人数，此项已禁用"}},
  "shift.template_label": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"模板"}},
  "shift.role_label": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"岗位"}},
  "shift.export_label": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"导出"}},
  "shift.ics_tooltip": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"将下载一个 ICS 文件，请使用您的日历应用打开。"}},
  "shift.repeat_request_error": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"无法在重复班次上提交排班申请。请改为创建新班次。"}},
  "slot_modal.roles_label": {"t":0,"b":{"t":2,"i":[{"t":3,"v":"岗位（"},{"t":4,"k":"count"},{"t":3,"v":"）"}]}},
  "slot_modal.no_roles": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"暂无岗位"}},
  "dash.label.pro_plus_attendance": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Pro+ 出勤"}},
  "dash.label.auto": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"自动"}},
  "dash.label.add_suffix": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":" 添加"}},
  "dash.label.none_suffix": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":" 无"}},
  "shift.created_label": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"创建： "}},
  "shift.edited_label": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"编辑： "}},
  "shift.new_shift_badge": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"新班次"}},
  "shift.repeat_staff_request_block": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"如果已设置排班申请，则员工提交的班次无法转为重复班次。"}},
  "shift.log_created": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":" 创建了该班次。"}},
  "shift.log_created_with_time": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"已为 %s 创建班次。"}},
  "shift.log_modified": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"从 %s 更改为 %s。"}},
  "shift.log_locked": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":" 确定了该班次。"}},
  "shift.log_unlocked": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":" 取消确定了该班次。"}},
  "shift.log_asked": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":" 申请了该班次。"}},
  "shift.log_accepted": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":" 批准了该班次。"}},
  "shift.log_rejected": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":" 拒绝了该班次。"}},
  "shift.log_copied": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"该班次已被复制。"}},
  "shift.log_moved": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"该班次已被移动。"}},
  "shift.comment_added_prefix": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"由于添加了评论，"}},
  "shift.repeat_unlink_confirm": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"%s该重复班次将被取消关联并变更为新班次，确定继续吗？"}},
  "shift.repeat_apply_all_confirm": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"这将应用于所有相关的重复班次，确定继续吗？"}},
  "shift.branch_punch_unsupported_alert": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"无法在“oplus 排班管理”中扫描门店打卡二维码，请改用“oplus 打卡应用”。\n\n请在 AppStore 或 Google Play 商店中搜索“打刻”并安装打卡应用。"}},
  "shift.monthly_vacation_exceeded": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"已超出每月可申请的休息天数上限。"}},
  "shift.template_edit_title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"编辑模板"}},
  "shift.template_create_title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"创建模板"}},
  "shift.minutes_suffix": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":" 分钟"}},
  "shift.calendar_view": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"日历"}},
  "shift.list_view": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"列表"}},
  "shift.no_shifts": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"暂无班次"}},
  "shift.staff_requested_off_label": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"请假申请"}},
  "shift.kot_pto_label": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"KOT带薪休假"}},
  "shift.kot_half_pto_am_label": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"KOT上午休"}},
  "shift.kot_half_pto_pm_label": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"KOT下午休"}},
  "date_nav.year_range": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"1月1日 ~ 12月31日"}},
  "date_nav.year_label": {"t":0,"b":{"t":2,"i":[{"t":4,"k":"year"},{"t":3,"v":"年"}]}},
  "request.tab_individual": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"个人申请"}},
  "request.tab_management": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"申请/审批管理"}},
  "request.confirm_action": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"确定要%s吗？"}},
  "request.confirm_undo": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"确定要撤销吗？"}},
  "request.oplus_support": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"oplus 客服"}},
  "request.undo": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"撤销"}},
  "request.status_header_manager": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"处理"}},
  "request.status_header_staff": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"状态"}},
  "request.pending_title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"待处理申请"}},
  "request.col_date": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"日期"}},
  "request.col_staff": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"员工"}},
  "request.col_category": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"类别"}},
  "request.col_note": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"备注"}},
  "request.col_manager": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"管理者"}},
  "request.col_approvals": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"审批数"}},
  "request.empty_title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"暂无申请"}},
  "request.empty_subtitle": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"请使用上方的创建按钮提交申请。"}},
  "request.history_title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"申请历史"}},
  "request.col_result": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"结果"}},
  "request.select_category_alert": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"请选择类别。"}},
  "request.select_category_placeholder": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"请选择类别"}},
  "request.confirm_delete": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"确定要删除吗？"}},
  "request.modal_title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"申请"}},
  "request.category.1": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"带薪休假"}},
  "request.category.2": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"半天带薪休假"}},
  "request.category.3": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"无薪休假"}},
  "request.category.4": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"早退"}},
  "request.category.5": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"迟到"}},
  "request.category.6": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"提前上班"}},
  "request.category.7": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"加班/迟到"}},
  "request.category.8": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"排班申请"}},
  "request.category.9": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"排班变更"}},
  "request.category.10": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"其他"}},
  "request.status.1": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"待处理"}},
  "request.status.2": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"已批准"}},
  "request.status.3": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"已拒绝"}},
  "request.status.4": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"已取消"}},
  "pto.status_title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"使用状况"}},
  "pto.col_acquired_date": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"获得日期"}},
  "pto.col_held_days": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"持有天数"}},
  "pto.col_used_days": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"已使用天数"}},
  "pto.col_expired_days": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"已过期天数"}},
  "pto.col_remaining_days": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"剩余天数"}},
  "pto.empty_title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"暂无带薪休假信息。"}},
  "pto.empty_subtitle": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"%s 当前没有可申请的带薪休假。"}},
  "pto.over_limit_notice": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"带薪休假使用量已超出持有天数。"}},
  "pto.request_result_title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"申请结果"}},
  "pto.request_btn": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"申请带薪休假"}},
  "pto.col_approval": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"审批"}},
  "pto.col_branch": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"门店名称"}},
  "pto.col_approver": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"审批人"}},
  "pto.approved": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"已批准"}},
  "pto.empty_history_title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"暂无申请历史。"}},
  "pto.empty_history_subtitle": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"%s 没有已批准或已拒绝的带薪休假记录。"}},
  "pto.delete_other_branch_alert": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"无法删除在其他门店已批准或已拒绝的带薪休假。请切换到该门店后再删除。"}},
  "pto.delete_confirm": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"确定要删除吗？"}},
  "pto.desired_date": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"期望日期"}},
  "date.full_date": {"t":0,"b":{"t":2,"i":[{"t":4,"k":"year"},{"t":3,"v":"年"},{"t":4,"k":"month"},{"t":4,"k":"day"},{"t":3,"v":"日 ("},{"t":4,"k":"weekday"},{"t":3,"v":")"}]}},
  "date.numeric_short_date": {"t":0,"b":{"t":2,"i":[{"t":4,"k":"month"},{"t":3,"v":"/"},{"t":4,"k":"day"},{"t":3,"v":" ("},{"t":4,"k":"weekday"},{"t":3,"v":")"}]}},
  "timecard.greeting": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"%s"}},
  "timecard.already_punched_in": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"您已打卡上班。"}},
  "timecard.already_punched_out": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"您已打卡下班。"}},
  "timecard.punch_in": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"上班打卡"}},
  "timecard.punch_out": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"下班打卡"}},
  "timecard.rest_start": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"开始休息"}},
  "timecard.rest_end": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"结束休息"}},
  "timecard.geolocation_loading": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"正在获取位置信息，请稍候。"}},
  "timecard.labor_col": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"工时"}},
  "timecard.missing_punch": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"缺勤打卡"}},
  "timecard.missing_punch_header": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"以下门店检测到缺失打卡记录：\n"}},
  "timecard.missing_punch_line": {"t":0,"b":{"t":2,"i":[{"t":3,"v":"\n门店："},{"t":4,"k":"name"},{"t":3,"v":"\n打卡时间："},{"t":4,"k":"time"},{"t":3,"v":"\n"}]}},
  "timecard.auto_delete_message": {"t":0,"b":{"t":2,"i":[{"t":3,"v":"由于上班与下班打卡之间的时间不超过 "},{"t":4,"k":"minutes"},{"t":3,"v":" 分钟，该打卡记录已被删除。"}]}},
  "board.intro_message": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"这是用于向所有员工发送邮件的功能，可用于发布报告、协调排班等。"}},
  "board.title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"公告板"}},
  "board.message_modal_title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"公告板消息"}},
  "board.send_all_branches": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"发送至所有门店"}},
  "board.notify_to": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"通知对象"}},
  "board.everyone": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"所有人"}},
  "board.role_shift_leader": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"排班编辑者"}},
  "board.role_staff": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"员工"}},
  "board.message_label": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"消息"}},
  "board.edited_suffix": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"（已编辑）"}},
  "board.comments_label": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"评论"}},
  "board.confirm_delete_message": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"确定要删除此消息吗？"}},
  "board.original_image_size": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"原始图片大小"}},
  "board.deleted_reload_alert": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"该公告板帖子已被删除，请刷新页面。"}},
  "feedback.description": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"为了帮助我们改进服务，请分享您的反馈。我们会认真审阅所有反馈，并用于改进今后的服务。"}},
  "feedback.category_opinion": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"意见反馈/咨询"}},
  "feedback.category_materials": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"申请资料"}},
  "feedback.category_demo": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"申请演示"}},
  "feedback.category_bug": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"故障报告"}},
  "feedback.contact_intro_line1": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"如有其他问题或需要帮助，"}},
  "feedback.contact_intro_line2": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"请在此联系我们。"}},
  "feedback.phone_contact_title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"电话联系"}},
  "feedback.business_hours": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"工作日 9:00 - 18:00"}},
  "profile_photo.title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"个人头像"}},
  "profile_photo.import": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"上传个人头像"}},
  "profile_photo.browse": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"浏览"}},
  "profile_photo.select": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"选择文件"}},
  "profile_photo.drag": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"把文件拖拽到此区域"}},
  "profile_photo.upload": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"上传文件"}},
  "profile_photo.error_format": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"不是影像档，目前只支援jpg/ jpeg/ png。"}},
  "profile_photo.error_size": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"档案太大，请上传10MB以下的档案。"}}
}
export default resource